import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { eventsAction } from "../redux/events-slice";
import useHttps from "./useHttps";
import useReporting from "./useReporting";
import axios from "axios";

// eslint-disable-next-line no-undef
const cloudiaryUploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;
// eslint-disable-next-line no-undef
const cloudiaryName = process.env.REACT_APP_CLOUDINARY_NAME;

const useEvents = () => {
   const { sendRequest } = useHttps();
   const dispatch = useDispatch();
   const { apiErrorReportingService, reportingService } = useReporting();
   const {
      events: { eventResponse, event },
   } = useSelector((state) => state);

   const [openDialog, setOpenDialog] = useState(false);

   const closeDeleteDialog = () => {
      setOpenDialog(false);
      dispatch(eventsAction.setSingleEvent({}));
   };

   const openDeleteDialog = () => {
      setOpenDialog(true);
   };

   const deleteEvent = () => {
      closeDeleteDialog();
      const config = {
         url: `event/remove-event/${event.id}`,
         method: "delete",
      };
      sendRequest(
         config,
         addEventsSuccess,
         getEventLoaderFunc,
         apiErrorReportingService
      );
   };

   const getEventsSuccess = (data) => {
      dispatch(eventsAction.setEventsResponse(data?.data));
   };

   const openEventsForm = () => {
      dispatch(eventsAction.setOpenForm(true));
   };

   const createEventLoaderFunc = (value) => {
      dispatch(eventsAction.setCreateLoading(value));
   };

   const eventError = (value) => {
      dispatch(eventsAction.setEventsResponse({}));
      apiErrorReportingService(value);
   };

   const searchEvents = (value) => {
      const searchValue = value ? `eventTitle:${value.trim()}*` : "";

      getEvents({ pageSize: 10, pageNo: 0, search: searchValue });
   };

   const getEventLoaderFunc = (value) => {
      dispatch(eventsAction.setGetLoading(value));
   };
   const getEvents = useCallback(
      ({ pageSize = 10, pageNo = 0, sortBy = "id", search = "" }) => {
         const config = {
            method: "get",
            url: `event/get-events?pageSize=${pageSize}&pageNo=${pageNo}&sortBy=${sortBy}&search=${search}`,
         };

         sendRequest(config, getEventsSuccess, getEventLoaderFunc, eventError);
      },
      [sendRequest]
   );

   const cloudinaryApi = async (imageSelected) => {
      const formData = new FormData();
      formData.append("file", imageSelected);
      formData.append("upload_preset", cloudiaryUploadPreset);
      try {
         dispatch(eventsAction.setCreateLoading(true));
         const responseData = await axios.post(
            `https://api.cloudinary.com/v1_1/${cloudiaryName}/image/upload`,
            formData
         );
         dispatch(eventsAction.setCreateLoading(false));
         reportingService(`File uploaded successfully`, "success");

         return responseData.data;
      } catch (err) {
         reportingService(`Couldn't upload file to cloudiary`, "error");
         dispatch(eventsAction.setCreateLoading(false));
      }
   };

   const addEventsSuccess = () => {
      closeEventsForm();
      reportingService("Events updated Successfully", "success");
      const pageSize = eventResponse?.pageable?.pageSize ?? 10;
      const pageN0 = eventResponse?.pageable?.pageNumber ?? 0;
      getEvents(pageSize, pageN0);
   };

   const closeEventsForm = () => {
      dispatch(eventsAction.setSingleEvent({}));
      dispatch(eventsAction.setOpenForm(false));
   };
   const addEvent = useCallback(
      (body) => {
         const config = {
            data: body,
            url: `event/create-update-event`,
            method: "post",
         };

         sendRequest(
            config,
            addEventsSuccess,
            createEventLoaderFunc,
            apiErrorReportingService
         );
      },
      [eventResponse, sendRequest]
   );

   return {
      getEvents,
      addEvent,
      openEventsForm,
      closeEventsForm,
      cloudinaryApi,
      openDialog,
      closeDeleteDialog,
      openDeleteDialog,
      deleteEvent,
      searchEvents,
   };
};

export default useEvents;
